import { Field, Input } from '@/components/ui/Input';

/**
 * Penanda waktu yang dikenali, beserta contoh hasilnya. Sama persis dengan
 * daftar di `server/src/services/naming.service.js` - pratinjau ini dihitung
 * di klien supaya terasa seketika, jadi kedua daftar harus tetap sama.
 */
// {w2w} sengaja tidak ada di sini lagi.
//
// Penanda itu memakai tanggal SENIN minggu berjalan, bukan tanggal hari
// berkasnya dibuat, dan perbedaan itu membingungkan setiap kali orang
// membandingkan nama berkas dengan waktu eksekusinya. Jadwal mingguan sekarang
// memakai {d2d} seperti yang lain: tanggal hari itu juga.
//
// Server MASIH bisa menerjemahkannya, supaya jadwal lama yang polanya sudah
// memuat {w2w} tidak tiba-tiba menghasilkan nama berkas berisi tulisan
// "{w2w}" apa adanya.
const PENANDA = [
  ['{d2d}', 'harian', (w) => `${w.yyyy}${w.mm}${w.dd}`],
  ['{m2m}', 'bulanan', (w) => `${w.yyyy}${w.mm}`],
  ['{h2h}', 'per jam', (w) => `${w.yyyy}${w.mm}${w.dd}_${w.hh}${w.MM}`],
];

const PENANDA_BAWAAN = {
  hourly: '{h2h}',
  daily: '{d2d}',
  weekly: '{d2d}',
  monthly: '{m2m}',
  cron: '{d2d}_{hh}{MM}',
  once: '',
};

/** Bagian waktu sekarang menurut Asia/Jakarta, sama seperti sisi server. */
const bagianWaktu = () => {
  const ambil = (tanggal) => {
    const bagian = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Jakarta',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(tanggal);
    const g = (j) => bagian.find((p) => p.type === j)?.value ?? '';
    return { yyyy: g('year'), mm: g('month'), dd: g('day'), hh: g('hour') === '24' ? '00' : g('hour'), MM: g('minute') };
  };

  const sekarang = ambil(new Date());
  const lokal = new Date(`${sekarang.yyyy}-${sekarang.mm}-${sekarang.dd}T00:00:00Z`);
  lokal.setUTCDate(lokal.getUTCDate() - ((lokal.getUTCDay() + 6) % 7));
  return { ...sekarang, senin: ambil(lokal) };
};

export const terapkanPola = (pola) => {
  const w = bagianWaktu();
  const nilai = {
    d2d: `${w.yyyy}${w.mm}${w.dd}`,
    w2w: `${w.senin.yyyy}${w.senin.mm}${w.senin.dd}`,
    m2m: `${w.yyyy}${w.mm}`,
    h2h: `${w.yyyy}${w.mm}${w.dd}_${w.hh}${w.MM}`,
    yyyy: w.yyyy,
    mm: w.mm,
    dd: w.dd,
    hh: w.hh,
    MM: w.MM,
  };
  return String(pola ?? '').replace(/\{(\w+)\}/g, (utuh, k) =>
    Object.prototype.hasOwnProperty.call(nilai, k) ? nilai[k] : utuh,
  );
};

/**
 * Isian pola nama berkas hasil, lengkap dengan pratinjau langsung.
 *
 * Pratinjau ada karena penanda seperti `{d2d}` tidak berarti apa-apa sampai
 * seseorang melihat hasilnya. Tanpa contoh yang berubah saat diketik, pola ini
 * hanya akan diisi asal lalu ketahuan salah seminggu kemudian.
 */
export const PolaNama = ({ nilai, tipe, namaJob = 'hasil', onUbah }) => {
  const efektif = nilai?.trim() || `${namaJob || 'hasil'}-${PENANDA_BAWAAN[tipe] ?? '{d2d}'}`;
  const w = bagianWaktu();

  return (
    <div className="space-y-2">
      <Field
        label="Pola nama berkas"
        hint="Kosongkan untuk memakai nama job ditambah penanda waktu bawaan."
      >
        {(p) => (
          <Input
            {...p}
            value={nilai}
            placeholder={`${namaJob || 'hasil'}-${PENANDA_BAWAAN[tipe] ?? '{d2d}'}`}
            className="font-mono text-sm"
            onChange={(e) => onUbah(e.target.value)}
          />
        )}
      </Field>

      <div className="rounded-lg bg-[var(--surface-sunken)] p-3">
        <p className="text-xs text-[var(--text-muted)]">
          Kalau berjalan sekarang, berkasnya bernama:
        </p>
        <p className="mt-1 font-mono text-sm font-semibold text-[var(--text-primary)]">
          {terapkanPola(efektif)}
        </p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {PENANDA.map(([tanda, keterangan, hitung]) => (
            <button
              key={tanda}
              type="button"
              title={`${keterangan}: ${hitung(w)}`}
              onClick={() => onUbah(`${nilai ?? ''}${tanda}`)}
              className="rounded-md border border-[var(--border-default)] px-2 py-1 font-mono text-[11px] text-[var(--text-secondary)] transition-colors hover:bg-[var(--surface-raised)]"
            >
              {tanda} <span className="text-[var(--text-muted)]">{hitung(w)}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
